// WooCommerce Styles
import "../sass/woocommerce.scss";

// Import quantity buttons
import {
  initQuantityButtons,
  reinitializeQuantityButtons,
} from "./modules/quantity-buttons.js";



/**
 * Initialize WooCommerce frontend scripts
 */
function initWooCommerceScripts() {

  // Quantity buttons
  initQuantityButtons();

  // Quantity validation for manual input
  document.querySelectorAll("input.qty").forEach((input) => {
    input.addEventListener("change", function () {
      const min = parseInt(this.getAttribute("min")) || 1;
      const max = parseInt(this.getAttribute("max")) || 999;
      let value = parseInt(this.value) || min;
      if (value < min) value = min;
      if (value > max) value = max;
      this.value = value;
    });
  });

  // Variation selection feedback
  const variationForm = document.querySelector(".variations_form");
  if (variationForm) {
    variationForm.querySelectorAll("select").forEach((select) => {
      select.addEventListener("change", () => {
        select.parentElement.classList.add("selected");
      });
    });
  }
}

/**
 * WooCommerce AJAX event handling
 */
function handleWooCommerceAjax() {
  if (typeof jQuery !== "undefined") {
    jQuery(document).on("updated_wc_div wc_fragments_refreshed", () => {
      reinitializeQuantityButtons();
    });
  }
}

/**
 * DOM ready
 */
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initWooCommerceScripts);
} else {
  initWooCommerceScripts();
}

// Listen for WooCommerce AJAX updates
handleWooCommerceAjax();
